<template>
    <div style="width:100%">
       <el-form-item :label="$t('field.feedbackNo')">
         <el-select v-model="selectValue" filterable remote  :remote-method="remoteMethod" clearable :loading="loading" @change="() => this.$emit('sync-select-feedback', selectValue)" 
             style="display:block;" :placeholder="$t('msg.fuzzy1WordSearch')" loading-text="loading..." :no-match-text="$t('msg.noDataFound')" :no-data-text="$t('msg.noDataFound')" :disabled="pOnlyView">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
       </el-form-item>

    </div>
</template>

<script>

import { apiFindFeedbackByCondition } from "../../utils/api.js";
import authHeader from "../../services/auth-header";


export default {   
    props: {
      pSelectValue: {
        type: String
      },
      pOnlyView: {
        type: Boolean,
        default: false
      }       
    },
    data() {
      return {
        options: [],
        loading: false,
        selectValue:''
      }
    },
    watch:{
      pSelectValue: function(){
        if(this.pSelectValue == null || this.pSelectValue ==''){
            this.selectValue = '';
            this.options = [];
        }else{
          this.selectValue = this.pSelectValue;
        }
      } 
    },
    mounted(){
      if(this.pSelectValue != null && this.pSelectValue !=''){
        this.selectValue = this.pSelectValue;
      }
    },
    methods: {
      remoteMethod(query) {
        if (query !== '') {
          this.loading = true;
          
          apiFindFeedbackByCondition({ headers: authHeader(), condition:query}).then((response) => { 
            this.options = [];
            var temp = [];
            response.data.forEach( function ( item, index, array)  { 
              var symptom = item.symptom;
              if(item.symptom!=null && item.symptom!= '' && item.symptom.length >20){
                symptom = item.symptom.substring(0,20)+'...';
              }                   
              temp.push({value:item.requestNo, label: symptom+'('+item.requestNo+')' });
            });
            this.options = temp; 
            this.loading = false;
          }).catch((err) => {
            console.log(err);
          });

        } else {
          this.options = [];
        }
      }
    }
}
</script>

<style scoped>
   
</style>